import React from 'react'
import Navbar from '../../components/Navbar'
import { Box,List,  ListItem, Typography, Card, Grid } from '@mui/material'
import ArrowRightIcon from '@mui/icons-material/ArrowRight';
import Footer from '../../components/Footer'
const DoNDont=({
 
  ImageLoc="/imgs/Bg1.jpg", 
  shouldWrap = true,
  

})=> {

  const ListContent1=["Be a registered Library User",
  "Present Library Card on entry, borrowing books for home use",
  "Respect Library Rules and Regulations",
  "Always come to the library prepared (identify your needs/know what you want)",
  "Use all the Library Resources",
  "Use all Library Sections",
  "Use Library PCs only for research/academic works",
  "Pay Library dues"]


  const ListContent2=["Do not make noise in the library (or its surroundings).",
  "Do not use cell phones inside the library",
  "Do not steal (all items are library property) from the library",
  "Do not listen to music while in the library",
  "Do not sleep inside the library",
  "Do not talk loudly or walk noisily inside the library",
  "Do not carry/move any item out (chairs, tables, books, etc.) without permission from Library",
  "Do not carry bags inside the library ", 
  "Do not remove or plug in your own peripheral devices",
  "Do not bring eatables like snacks and beverages inside the library."]

  return (
    <div>
    <Box top={0} position={'sticky'}><Navbar/></Box>
    <Box overflow={'hidden'} sx={{ zIndex:'-12', position: 'relative',  height: '50vh' }}>
      <img
        src={ImageLoc}
        alt="Background "
        style={{
          objectFit:'cover',
          width: '100%',
          height: '100%',
        }}
      />
      
        <Typography variant='h3'   color={'#fff'}  sx={{py:2, backgroundColor:'rgba(0,0,0,0.5)',  position: 'absolute', bottom: 0, width:1 }}>
        Dos and Don’ts
        </Typography>
   </Box>
   <Grid container spacing={4} sx={{ display: 'flex',p:'3%' }}>
     
     
     
      {/* Column 1 */}
      <Grid item xs={12} lg={6}>
        <Card sx={{backgroundColor:'primary.light'}}>
          <List >
          <Typography variant='h5' p={2} textAlign={'left'}>Dos</Typography>
            {ListContent1.map((item, key) => (
              <ListItem key={key} sx={{ p: 2 }}>
        
                  <ArrowRightIcon color='primary.main' fontSize='large' />
        
                <Typography>{item}</Typography>
              </ListItem>
            ))}
          </List>
        </Card>
      </Grid>


      {/* Column 2 */}
      <Grid item xs={12} lg={6}>
        <Card sx={{backgroundColor:'primary.light'}}>
          <List >
          <Typography variant='h5' p={2} textAlign={'left'}>Dos</Typography>
            {ListContent2.map((item, key) => (
              <ListItem key={key} sx={{ p: 2 }}>
        
                  <ArrowRightIcon color='primary.main' fontSize='large' />
        
                <Typography>{item}</Typography>
              </ListItem>
            ))}
          </List>
        </Card>
      </Grid>

    </Grid>
<Footer/>
</div>
  )
}
export default DoNDont
